exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  padding: 15px;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.zoom-outer-container {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  position: relative;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  gap: 25px; }\n\n.pdf-btn-container {\n  position: absolute;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  gap: 25px;\n  top: 15px;\n  right: 0;\n  padding: 0;\n  margin-right: 30px;\n  -ms-flex-align: center;\n      align-items: center; }\n\n#xIcon {\n  position: relative;\n  top: -4px;\n  margin-left: 4rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/modals/pdf-view-modal/pdf-view-modal.component.scss
// module id = ../../../../../src/app/shared/modals/pdf-view-modal/pdf-view-modal.component.scss
// module chunks = main